import React from "react";
import "./ServiceSection.css";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faScrewdriverWrench,
  faChartLine,
  faFlask,
  faWater,
} from "@fortawesome/free-solid-svg-icons";

function ServiceSection() {
  const { t } = useTranslation("home");
  return (
    <section className="service-section">
      <div className="container">
        <h2>{t("serviceSection.heading")}</h2>
      </div>
      <div className="container service-container">
        <div className="service-card">
          <div className="card-icon">
            <FontAwesomeIcon icon={faScrewdriverWrench} />
          </div>
          <div>
            <h6>{t("serviceSection.firstCardHeading")}</h6>
            <p className="small">{t("serviceSection.firstCardContent")}</p>
          </div>
        </div>
        <div className="service-card">
          <div className="card-icon">
            <FontAwesomeIcon icon={faChartLine} />
          </div>{" "}
          <div>
            <h6>{t("serviceSection.secoundCardHeading")}</h6>
            <p className="small">{t("serviceSection.secoundCardContent")}</p>
          </div>
        </div>
        <div className="service-card">
          <div className="card-icon">
            <FontAwesomeIcon icon={faFlask} />
          </div>{" "}
          <div>
            <h6>{t("serviceSection.thirdCardHeading")}</h6>
            <p className="small">{t("serviceSection.thirdCardContent")}</p>
          </div>
        </div>
        <div className="service-card">
          <div className="card-icon">
            <FontAwesomeIcon icon={faWater} />
          </div>{" "}
          <div>
            <h6>{t("serviceSection.fourthCardHeading")}</h6>
            <p className="small">{t("serviceSection.fourthCardContent")}</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ServiceSection;
